import Constants from 'expo-constants';
import { Platform as RNPlatform } from 'react-native';

import { WEB_TV_DETECTORS } from './constants';

export type TVDetection = {
  isTV: boolean;
  vendor?: string | null;
  osName?: string | null;
  simulated: boolean;
};

export function detectWebTV(): TVDetection {
  if (RNPlatform.OS !== 'web') {
    return { isTV: false, vendor: null, osName: null, simulated: false };
  }

  const ua = navigator?.userAgent ?? Constants.expoConfig?.extra?.defaultUserAgent ?? '';

  for (const detector of WEB_TV_DETECTORS) {
    if (!detector.regex.test(ua)) continue;

    const api = detector.apiAvailable();

    return {
      isTV: true,
      vendor: detector.vendor,
      osName: detector.osName,
      simulated: !api,
    };
  }

  return { isTV: false, vendor: null, osName: null, simulated: false };
}
